import Chats from '@mds/icons/Chats';
import { useContext } from 'react';
import { AccountMenuItemButton, AccountMenuItemButtonProps } from '../AccountMenuItem';
import { AccountMenuContext } from './context';

/**
 * Link to Neon Support Center.
 *
 * Not shown when the user is logged out.
 */
export function NeonSupportCenterLink({
  url = '/support',
  user: userProp,
  ...rest
}: {
  /**
   * Optional, defaults to Neon Support Center url
   */
  url?: string;
  /**
   * Defaults to user prop passed to <AppBarLayout>
   */
  user?: unknown;
} & Partial<AccountMenuItemButtonProps>) {
  const accountMenuContext = useContext(AccountMenuContext)!;
  const user = userProp ?? accountMenuContext.user;

  if (!user) {
    return null;
  }

  return (
    <AccountMenuItemButton icon={<Chats />} component="a" href={url} {...rest}>
      Support Centre
    </AccountMenuItemButton>
  );
}
